/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  TableOfContentsDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiTableOfContents = (
    tableOfContentsDto?: BodyType<TableOfContentsDto>,
 signal?: AbortSignal
) => {


      return customInstance<TableOfContentsDto>(
      {url: `/api/TableOfContents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tableOfContentsDto, signal
    },
      );
    }




export const getPostApiTableOfContentsMutationKey = () => ['postApiTableOfContents'] as const;

export const getPostApiTableOfContentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTableOfContents>>, TError,PostApiTableOfContentsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiTableOfContents>>, TError,PostApiTableOfContentsMutationVariables, TContext> => {

const mutationKey = getPostApiTableOfContentsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiTableOfContents>>, PostApiTableOfContentsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postApiTableOfContents(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiTableOfContentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTableOfContents>>>
    export type PostApiTableOfContentsMutationBody = BodyType<TableOfContentsDto> | undefined
    export type PostApiTableOfContentsMutationError = ErrorType<unknown>
    export type PostApiTableOfContentsMutationVariables = {data?: BodyType<TableOfContentsDto>}

    export const usePostApiTableOfContents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTableOfContents>>, TError,PostApiTableOfContentsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiTableOfContents>>,
        TError,
        PostApiTableOfContentsMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiTableOfContentsMutationOptions(options), queryClient);
    }
    export const getApiTableOfContentsProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<TableOfContentsDto>(
      {url: `/api/TableOfContents/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiTableOfContentsProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/TableOfContents/${projectId}`
    ] as const;
    }


export const getGetApiTableOfContentsProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTableOfContentsProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>> = ({ signal }) => getApiTableOfContentsProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTableOfContentsProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>>
export type GetApiTableOfContentsProjectIdQueryError = ErrorType<unknown>


export function useGetApiTableOfContentsProjectId<TData = Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTableOfContentsProjectId<TData = Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTableOfContentsProjectId<TData = Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTableOfContentsProjectId<TData = Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTableOfContentsProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTableOfContentsProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






